import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-radiography',
  templateUrl: './radiography.component.html',
  styleUrls: ['./radiography.component.scss']
})
export class RadiographyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
